/** @format */

import { Box, Button } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { useAppDispatch, useAppSelector } from '../../app/hooks';
import { useApiFeedback } from '../../app/useApiFeedback';
import { GetOtpThunk, selectLogin } from '../../features/login/loginSlice';
import MessageResponse from '../feedback/messageResponse';

function resolveExpirySeconds(raw: unknown): number {
  if (typeof raw === 'number' && Number.isFinite(raw)) return raw;
  if (raw && typeof raw === 'object' && 'expiryDate' in raw) {
    const v = (raw as { expiryDate: unknown }).expiryDate;
    if (typeof v === 'number' && Number.isFinite(v)) return v;
  }
  return 0;
}

interface Props {
  initialSeconds: number | { expiryDate?: number } | unknown;
  username: string;
  setExpiryDate: React.Dispatch<React.SetStateAction<number | null>>;
}
export default function CountDownTimer({
  initialSeconds,
  username,
  setExpiryDate,
}: Props) {
  const [seconds, setSeconds] = useState(() =>
    resolveExpirySeconds(initialSeconds)
  );
  const loginSelect = useAppSelector(selectLogin);
  const { feedback, handleApiResponse } = useApiFeedback();

  const dispatch = useAppDispatch();
  const handleResendCode = () => {
    dispatch(GetOtpThunk(username)).then((resp: any) => {
      if (resp?.type?.endsWith?.('/fulfilled')) {
        const next = resolveExpirySeconds(resp.payload?.data);
        if (next > 0) {
          setSeconds(next);
          setExpiryDate(next);
        }
      }
      handleApiResponse(resp, false);
    });
  };

  useEffect(() => {
    if (seconds <= 0) {
      return;
    }

    const timer = setInterval(() => {
      setSeconds((prevSeconds: number) => prevSeconds - 1);
    }, 1000);

    return () => clearInterval(timer);
  }, [seconds]);

  const formatTime = (timeInSeconds: number) => {
    const minutes = Math.floor(timeInSeconds / 60)
      .toString()
      .padStart(2, '0');
    const seconds = (timeInSeconds % 60).toString().padStart(2, '0');
    return `${minutes}:${seconds}`;
  };

  useEffect(() => {
    const next = resolveExpirySeconds(loginSelect.loginState.expiryDate);
    if (next > 0) {
      setSeconds(next);
      setExpiryDate(next);
    }
  }, [loginSelect.loginState.expiryDate, setExpiryDate]);

  return (
    <>
      <MessageResponse feedback={feedback} />
      {seconds > 0 && (
        <Box
          sx={{
            color: 'rgba(0, 0, 0, 0.6)',
            fontWeight: 500,
            fontSize: '14px',
            fontStyle: 'italic',
          }}>
          In case you did not receive the OTP you can resend after:{' '}
          {formatTime(seconds)}
        </Box>
      )}
      {seconds <= 0 && (
        <Box sx={{ color: 'rgba(0, 0, 0, 0.6)', fontWeight: 500, mt: 1 }}>
          Did not receive OTP?{' '}
          <Button variant="outlined" onClick={() => handleResendCode()}>
            Resend
          </Button>
        </Box>
      )}
    </>
  );
}
